import * as Yup from 'yup';
import { formatCode } from 'src/utils/formatters';
import { buildYupField } from 'src/components/formik/yup-field-builder';
import { getDefaultItemId } from 'src/components/formik-utils';

export const formatCardFuel = (val) => {
  return formatCode(val, '-');
};

export const initialValues = (formik, item) => {
  if(!formik) return;

  let myId = 0;
  if (item != null && (Object.keys(item).length > 0 || item.constructor !== Object)) {
    myId = item.id;
  }
  
  formik.setFieldValue('id', myId);
  formik.setFieldValue('partnerField', null);
  formik.setFieldValue('groupField', null);
  formik.setFieldValue('pricingField', null);
};

export const validationSchema = (item) => {
  let schema = Yup.object();
  // const isCreate = item?.isCreate;
  // schema.shape({
  //   groupField: isCreate ? Yup.object().required('Vui lòng chọn đơn vị') : Yup.string().nullable(),
  // });

  // schema = schema.shape({
  //   groupField: Yup.object()
  //     .nullable()
  //     .when([], {
  //       is: () => isCreate,
  //       then: (schema) => schema.required('Vui lòng chọn đơn vị'),
  //       otherwise: (schema) => schema.nullable(),
  //     }),
  //   });

  return schema;
};

export const handleSubmitted = async (
  values,
  item,
  apiChange,
  assignGroup,
) => {
  if(values.isVerified){
    const groupId = values.groupField?.value;
    if(0 < groupId){
      await assignGroup({carId: values.id, groupId: groupId});
    }
  }else{
    await apiChange(values);
  }
};

// Pagers
export const validationPagers = (isRequired) => {
  return Yup.object({
    pagersField: buildYupField({
      type: 'object',
      required: isRequired,
      label: 'Vui lòng chọn loại giấy tờ',
      rules: {
        requiredKeys: ['value']
      }
    }),
    expField: buildYupField({
      type: 'number',
      required: isRequired,
      label: 'Ngày hết hạn phải có',
      rules: {
        greaterThan: { value: 0, message: 'Ngày hết hạn phải có' }
      }
    }),
    image: buildYupField({
      type: 'file',
      required: isRequired,
      label: 'Hình giấy tờ yêu cầu phải có',
      rules: {
        mimeTypes: { value: ['image/jpeg', 'image/png'] },
        maxSize: { value: 2 * 1024 * 1024, message: 'Ảnh phải nhỏ hơn 2MB' }
      }
    })
  });
};

export const pagersSubmitted = async ( values, apiEditPagers, onCallback ) => {
  const {result, error} = await apiEditPagers(values);
  onCallback(result, error);
};
